<div class="row">
    <div class="text-center text-danger" *ngIf="!title"> Error Please try again later </div>
    <div class="text-center text-danger" *ngIf="title"> {{title}} </div>
    <div class="text-center mt-2">
        <button class="btn btn-primary" (click)="onReload()"><i class="fi fi-rr-rotate-right"></i> თავიდან ჩატვირთვა</button>
    </div>
</div>

